import React from 'react'
import './style.css'

export default function select(props) {
    return (
        <div className="form">
           <p>{props.select}</p>
           <div className="form-input">
               <select id={props.id}>
                  <option value={props.value1}>{props.option1}</option>
                  <option value={props.value2}>{props.option2}</option>
               </select>
               <small>{props.small}</small>
             </div>
          </div>
    )
}
